import { combineReducers } from "redux";
import mediaInfo from "../reducers/creators/mediaInfo";
import { EDIT_MEDIA_SCREEN_NAMESPACE } from "../../constants/store/editMedia";

export default combineReducers({
  info: mediaInfo(EDIT_MEDIA_SCREEN_NAMESPACE),
});
